import { render } from "./RecycleScroller.vue?vue&type=template&id=e4886504"
import script from "./RecycleScroller.vue?vue&type=script&lang=js"
export * from "./RecycleScroller.vue?vue&type=script&lang=js"

import "./RecycleScroller.vue?vue&type=style&index=0&id=e4886504&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__